<app-sidenav>
  <ng-template #sidenavContent>
    <app-pdf-reactor-header reportType="business">
      <app-card title="{{ 'content.this-order' | translate }}">
        <div class="sidecard-content">
          <div class="sidecard-row">
            <div><strong>{{ 'content.service' | translate }}</strong></div>
            <div>{{ bizInquiry.meta.memberInfo ? bizInquiry.meta.memberInfo.name : '' }}</div>
          </div>
          <div class="sidecard-row">
            <div><strong>{{ 'content.product-type' | translate }}</strong></div>
            <div>{{ productDescription }}</div>
          </div>
          <div class="sidecard-row pdf-reactor-d-none">
            <div><strong>{{ 'content.search-type' | translate }}</strong></div>
            <div>{{ 'content.keyed.prodtypes.' + searchType | translate }}</div>
          </div>
          <div class="sidecard-row pdf-reactor-d-none">
            <div><strong>{{ 'content.report-language' | translate }}</strong></div>
            @if (equalsIgnoreCase('en', bizInquiry.meta.language)) {
              <div>{{ 'content.english' | translate }}</div>
            }
            @if (equalsIgnoreCase('fr', bizInquiry.meta.language)) {
              <div>{{ 'content.french' | translate }}</div>
            }
          </div>
          <div class="sidecard-row">
            <div><strong>{{ 'content.reference-id' | translate }}</strong></div>
            <div>{{ bizInquiry.meta.userReference }}</div>
          </div>
          <div class="d-none pdf-reactor-block w-100"></div>
          <div class="sidecard-row">
            <div><strong>{{ 'content.issued-date' | translate }}</strong></div>
            @if (reportProcessed) {
              <div>{{ reformatDateMonth(bizInquiry.meta.timestamp) }}</div>
            }
            @if (noHitReport) {
              <div>{{ currentLLL }}</div>
            }
          </div>
        </div>
      </app-card>
    </app-pdf-reactor-header>
  </ng-template>

  <ng-template #mainContent>
    @if (noHitReport) {
      <div>
        <div class="new-order-row">
          <button class="tu-button primary tu-shadow" type="button" routerLink="/business-services">{{ 'content.new-order' | translate }}</button>
        </div>
        <div>
          <h2 class="content-main-title">{{ 'content.main-title' | translate }}</h2>
        </div>
        <div class="no-hit-header">{{ 'content.trans-union-of-canada' | translate | uppercase }}</div>
        <div class="center-message">
          {{ 'content.small-business-credit-report' | translate }}{{ 'content.date' | translate }}: <strong>{{ formatMonthDateYear(currentDate) }}</strong>
        </div>
        <div class="center-message">
          {{ 'content.unable-to-find-a-file-for' | translate }} <strong>{{ bizInquiry.meta.userReference }}</strong>
        </div>
      </div>
    }
    @if (reportProcessed) {
      <div>
        @if (_appCard && _creditReport) {
          <app-pdf-button-bar newOrderUrl="/business-services" [css]="businessReportCss" [documentRootElement]="[_appCard, _creditReport]">
          </app-pdf-button-bar>
        }
        <div #creditReport>
          <h1 class="content-main-title">{{ 'content.main-title' | translate }}</h1>
          <div class="credit-report">
            <div class="row pdf-reactor-column">
              <div class="col-sm-12 col-md-6 credit-report-image-bg d-flex align-items-end pdf-reactor-d-none">
                <div class="row w-100">
                  <div class="col-md-6 d-flex business-report-summary-tile green"></div>
                  <div class="col-md-6 d-flex business-report-summary-tile yellow">
                    @if (creditScore) {
                      <h2 class="tile-title no-underline">{{ 'content.credit-score' | translate }}</h2>
                    }
                    @if (creditScore) {
                      <div class="tile-exaggerated pb-3 d-flex align-items-center justify-content-center">{{ creditScore }}</div>
                    }
                  </div>
                  <div class="col-md-6 d-flex business-report-summary-tile red ps-4 pe-4">
                    @if (anyCreditScoreAlert()) {
                      <h2 class="tile-title no-underline">
                        {{ 'content.score-alerts' | translate }}
                      </h2>
                    }
                    @if (anyCreditScoreAlert()) {
                      <div class="flex-grow-1 ps-1">
                        <ul class="col-md-12">
                          @if (creditScoreAlert1) {
                            <li>{{creditScoreAlert1}}</li>
                          }
                          @if (creditScoreAlert2) {
                            <li>{{creditScoreAlert2}}</li>
                          }
                          @if (creditScoreAlert3) {
                            <li>{{creditScoreAlert3}}</li>
                          }
                          @if (creditScoreAlert4) {
                            <li>{{creditScoreAlert4}}</li>
                          }
                        </ul>
                      </div>
                    }
                  </div>
                  <div class="col-md-6 d-flex business-report-summary-tile green ps-2 pe-2">
                    @if (anyCreditScoreReason()) {
                      <h2 class="tile-title no-underline">
                        {{ 'content.score-factors' | translate }}
                      </h2>
                    }
                    @if (anyCreditScoreReason()) {
                      <div class="flex-grow-1 ps-1">
                        @for (codeDescription of ((getRsnCodeDescriptions() | async) | keyvalue); track codeDescription; let i = $index) {
                          <div class="col-md-12">
                            {{ i + 1 }}. {{ codeDescription.value }}
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="d-flex justify-content-around header-date-info">
                  <span>{{ currentDate }}</span>
                  <span>{{ 'content.on-file-date' | translate }}: {{ onFileDate }}</span>
                  <span>{{ 'content.last-updated' | translate }}: {{ lastUpdatedDate }}</span>
                </div>
                <ng-container *ngTemplateOutlet="titleBar; context:{titles:['content.transunion' | translate,'content.business-solutions' | translate],subtitle:'content.small-business-credit-report' | translate}"></ng-container>
                <div class="business-report-content business-identification-information break-before-avoid">
                  <h2 class="d-flex flex-row">{{ 'content.business-id-info' | translate }}
                    @if (address && address.soho === '1') {
                      <span>
                        <div class="building-icon">
                      <img alt="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAkCAYAAAAOwvOmAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH3gYEFQUeeVcdtQAAAeNJREFUWMPt189v2jAUB/CvfwhBIhUJpRzWFQo7VEFayw7T+v+fNvUCZWrVAwTC2gNMSK2UEEW1vMNElbUhweHR9cC7RYrtj/2enZhprUERk7GnmyctRtEXo0AN+j0dRRHK5TI+n3e3hnEqEABEUYRBv6f/KyoJWgUFjFOCqGCcGkQBM0Z5o2EuKAkbeyO9U9TYG+nf87nRAPPZzBjGTUDz2axQjZjC+K5BRWD8LUCmME4FklKSwTgF6LBex1n3C7NtmwTGKUAnrTYTQuDU7ZDAOAVo9UwF41QgStjzr0sRUBzHuL/79dxOSIlarYbjRpMBwO3NtQ6CwHiSTGtdGPRzcKXV09Ord2zbxqnbKQzjU98vlDJvNEwFAUAQBJj6E10klVPf19xxHCY2OGOSIKUUHh8eMt9fLBbGNSakhOM4jFcsC67byYS9LOplGOYOkFzFTWBCSrhuh1Us6+/uy4Kl7bKKZRl/YrJgSdA/R0IaLGvbH1SrueneBPYS9OqcSsLWgVbRaDTXplxIiQ9HH1neiqWB1l6x4jhGqVTKTckyDOH7E50s+oNqFa32J5bXXikFpVTqOCT3PqUUlmGIimVBCLF1f7JIo8sf3zeeyddvF8aX060vo7uIPWqP2qP2qPeO+gOxYFh49aOaDAAAAABJRU5ErkJggg=="/>
                      <!-- This is a decorative icon.  Use a "null" alt tag (alt="") to tell assistive tech to ignore it -->
                    </div>
                  </span>
}
                </h2>
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <h3>{{ 'content.names-primary-addresses' | translate }}</h3>
                    <div class="col-sm-12">
                      <h4 class="">{{ 'content.legal-name' | translate }}:</h4>
                      <div class=" business-report-value">{{ legalName && legalName.name }}</div>
                      <h4 class="">{{ 'content.operating-as' | translate }}:</h4>
                      <div class=" business-report-value">{{ operatingName && operatingName.name }}</div>
                      <h4 class="">{{ 'content.address.street' | translate }}:</h4>
                      <div class=" business-report-value">{{ address && address.street }}</div>
                      <h4 class="">{{ 'content.address.city' | translate }}:</h4>
                      <div class=" business-report-value">{{ address && address.city }}</div>
                      <h4 class="">{{ 'content.address.province' | translate }}:</h4>
                      <div class=" business-report-value">{{ address && address.prov }}</div>
                      <h4 class="">{{ 'content.address.postal-code' | translate }}:</h4>
                      <div class=" business-report-value">{{ address && reformatPostal(address.postal) }}</div>
                      <h4 class="">{{ 'content.phone.phone' | translate }}:</h4>
                      <div class=" business-report-value">{{ phone && reformatPhone(phone.number) }}</div>
                      <h4 class="">{{ 'content.naics-code' | translate }}:</h4>
                      <div class=" business-report-value">{{ naicsValue && naicsValue.value }}</div>
                      <h4 class="">{{ 'content.naics-desc' | translate }}:</h4>
                      <div class=" business-report-value">{{ naicsValue && naicsValue.text }}</div>
                      <h4 class="">{{ 'content.sic-code' | translate }}:</h4>
                      <div class=" business-report-value">{{ sicValue && sicValue.value }}</div>
                      <h4 class="">{{ 'content.sic-desc' | translate }}:</h4>
                      <div class=" business-report-value">{{ sicValue && sicValue.text }}</div>
                    </div>
                    <h3 class="pt-2">{{ 'content.credit-summary' | translate }}</h3>
                    <div class="col-sm-12">
                      <h4 class="">{{ 'content.reported-accounts-num' | translate }}:</h4>
                      <div class=" business-report-value">{{ numOfAccounts }}</div>
                      <h4 class="">{{ 'content.total-balance' | translate }}:</h4>
                      <div class=" business-report-value">{{ business && (i18nService.formatCurrency(business.totalBalances) | async) }}</div>
                      <h4 class="">{{ 'content.credit-utilization' | translate }}:</h4>
                      <div class=" business-report-value">{{ business && (i18nService.formatPercent(business.creditUtilizationPercentage / 100) | async) }}</div>
                      <h4 class="">{{ 'content.credit-limit' | translate }}:</h4>
                      <div class=" business-report-value">{{ business && (i18nService.formatCurrency(business.creditLimit) | async) }}</div>
                      <h4 class="">{{ 'content.insolvency' | translate }}:</h4>
                      <div class=" business-report-value">{{ business && (insolvencyPresent ? 'content.yes' : 'content.no') | translate }}</div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <h3>{{ 'content.registry-info' | translate }}</h3>
                    <div class="col-sm-12">
                      <h4 class="">{{ 'content.business-type' | translate }}:</h4>
                      <div class=" business-report-value">{{ entityType && entityType.text }}</div>
                      <h4 class="">{{ 'content.registration-num' | translate }}:</h4>
                      <div class=" business-report-value">{{ businessId && businessId.idNum }}</div>
                      <h4 class="">{{ 'content.registration-date' | translate }}:</h4>
                      <div class=" business-report-value">{{ businessId && formatDate(businessId.issueDt) }}</div>
                      <h4 class="">{{ 'content.business-status' | translate }}:</h4>
                      <div class=" business-report-value">{{ avsInfo && ((isBusinessActive() ? 'content.active' : 'content.inactive') | translate) }}</div>
                      <h4 class="">{{ 'content.status-updated' | translate }}:</h4>
                      <div class=" business-report-value">{{ avsInfo && formatDate(avsInfo.avsStatusDt) }}</div>
                      <h4 class="">{{ 'content.jurisdiction' | translate }}:</h4>
                      <div class=" business-report-value">{{ avsInfo && avsInfo.avsJurisdiction }}</div>
                    </div>
                    <h3 class="pt-2">{{ 'content.inquiry-input-info' | translate }}</h3>
                    <div class="col-sm-12">
                      <h4 class="">{{ 'content.business-operating-name' | translate }}:</h4>
                      <div class=" business-report-value">{{ bizInquiry.businesses[0].businessName }}</div>
                      <h4 class="">{{ 'content.business-legal-name' | translate }}:</h4>
                      <div class=" business-report-value">{{ bizInquiry.businesses[0].businessLegalName }}</div>
                      <h4 class="">{{ 'content.business-registry-info' | translate }}:</h4>
                      <div class=" business-report-value">{{ bizInquiry.businesses[0].businessRegInfoNum }}</div>
                      <h4 class="">{{ 'content.qualifier' | translate }}:</h4>
                      <div class=" business-report-value">{{ inquiryQualifier }}</div>
                      <h4 class="">{{ 'content.address.street' | translate }}:</h4>
                      <div class=" business-report-value">{{ bizInquiry.businesses[0].addresses[0].street }}</div>
                      <h4 class="">{{ 'content.address.city' | translate }}:</h4>
                      <div class=" business-report-value">{{ bizInquiry.businesses[0].addresses[0].city }}</div>
                      <h4 class="">{{ 'content.address.province' | translate }}:</h4>
                      <div class=" business-report-value">{{ bizInquiry.businesses[0].addresses[0].province }}</div>
                      <h4 class="">{{ 'content.address.postal-code' | translate }}:</h4>
                      <div class=" business-report-value">{{ reformatPostal(bizInquiry.businesses[0].addresses[0].postal) }}</div>
                      <h4 class="">{{ 'content.business-phone' | translate }}:</h4>
                      <div class=" business-report-value">{{ reformatPhone(bizInquiry.businesses[0].phones[0].phone) }}</div>
                    </div>
                    @if (businessIDMismatch) {
<div>
                      <h3 class="pt-2">{{ 'content.business-id-mismatch' | translate }}</h3>
                      <div class="row">
                        <div class="col-sm-12 business-report-value">{{ businessIDMismatch.message }}</div>
                      </div>
                    </div>
}
                  </div>
                </div>
              </div>
            </div>

            @if (anyCreditScoreInfo()) {
<div class="d-none pdf-reactor-block break-before mb-5">
              <div class="">
                @if (creditScore) {
<h2 class="">{{ 'content.credit-score' | translate }}</h2>
}
                @if (creditScore) {
<div class="">{{ creditScore }}</div>
}
              </div>
              <div class="">
                @if (anyCreditScoreAlert()) {
<h2 class="">
                  {{ 'content.score-alerts' | translate }}
                </h2>
}
                @if (anyCreditScoreAlert()) {
<div class="">
                  <ul class="col-md-12">
                    @if (creditScoreAlert1) {
<li>{{creditScoreAlert1}}</li>
}
                    @if (creditScoreAlert2) {
<li>{{creditScoreAlert2}}</li>
}
                    @if (creditScoreAlert3) {
<li>{{creditScoreAlert3}}</li>
}
                    @if (creditScoreAlert4) {
<li>{{creditScoreAlert4}}</li>
}
                  </ul>
                </div>
}
              </div>
              <div class="">
                @if (anyCreditScoreReason()) {
<h2 class="">
                  {{ 'content.score-factors' | translate }}
                </h2>
}
                @if (anyCreditScoreReason()) {
<div class="">
                  @for (codeDescription of ((getRsnCodeDescriptions() | async) | keyvalue); track codeDescription; let i = $index) {
<div class="col-md-12">
                    {{ i + 1 }}. {{ codeDescription.value }}
                  </div>
}
                </div>
}
              </div>
            </div>
}

          </div>
          <div class="col-sm-12" [ngClass]="{'break-before': !anyCreditScoreInfo()}">
            <ng-container *ngTemplateOutlet="titleBar; context:{titles:['content.transunion' | translate,'content.business-solutions' | translate],subtitle:'content.credit-report-data' | translate}"></ng-container>
            @if (business) {
<div class="business-report-content col-sm-12">
              <div class="col-sm-12 align-items-start">
                <div class="row">
                  @if (owners?.length > 0) {
<h3>{{ 'content.business-owner-profile' | translate }}</h3>
}
                </div>
                @for (owner of owners; track owner) {
<div class="row">
                  <div class="col-sm-12 col-md-6 col-lg-3 report-labelled-cell">
                    <h4 class="col-sm-12 p-1">{{ 'content.person.owner-name' | translate }}</h4>
                    @for (ownerName of owner.ownerNames; track ownerName) {
<div class="col-sm-12 p-1 value">
                      <div>{{ 'content.person.name' | translate }}: {{ formatOwnerName(ownerName) }}</div>
                      <div>{{ 'content.date-updated' | translate }}: {{ formatDate(ownerName.lastUpdatedDt) }}</div>
                      <div>{{ 'content.suffix' | translate }}: {{ ownerName.suffix }}</div>
                    </div>
}
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3 report-labelled-cell">
                    <h4 class="col-sm-12 p-1">{{ 'content.address.owner-address' | translate }}</h4>
                    @for (ownerAddress of owner.ownerAddresses; track ownerAddress) {
<div class="col-sm-12 p-1 value">
                      <div>{{ 'content.address.address' | translate }}: {{ formatAddress(ownerAddress) }}</div>
                      <div>{{ 'content.date-updated' | translate }}: {{ formatDate(ownerAddress.lastUpdatedDt) }}</div>
                    </div>
}
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3 report-labelled-cell">
                    <h4 class="col-sm-12 p-1">{{ 'content.phone.owner-phone' | translate }}</h4>
                    @for (ownerPhone of owner.ownerPhones; track ownerPhone) {
<div class="col-sm-12 p-1 value">
                      <div>{{ 'content.phone.phone' | translate }}: {{ reformatPhone(ownerPhone.number) }} {{ ownerPhone.phoneExt }}</div>
                      <div>{{ 'content.date-updated' | translate }}: {{ formatDate(ownerPhone.lastUpdatedDt) }}</div>
                    </div>
}
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3 report-labelled-cell">
                    <h4 class="col-sm-12 p-1">{{ 'content.ownership' | translate }}</h4>
                    <div class="col-sm-12 p-1 value">{{ i18nService.formatPercent(getOwnerPercent(owner)) | async }}</div>
                  </div>
                </div>
}
                @if (creditFreezeOwners?.length > 0) {
<div>
                  <h3>{{ 'content.credit-freeze' | translate }}</h3>
                  @for (owners of creditFreezeOwners; track owners) {
<div class="row">
                    {{ 'content.credit-freeze-msg-small-business' | translate:{freezedate: owners.freezeDate} }}
                  </div>
}
                </div>
}
                <div [ngClass]="{'break-before': owners?.length > 0}">
                  <h3>{{ 'content.additional-business-info' | translate }}</h3>
                </div>
                @if (bizInfo) {
<div class="row">
                  <div class="col-sm-12 col-md-6 col-lg-3 report-labelled-cell">
                    <h4 class="p-1">{{ 'content.annual-sales-volume' | translate }}</h4>
                    <div class="p-1 value">{{ i18nService.formatCurrency(bizInfo.igActualSalesCorp) | async }}</div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3 report-labelled-cell">
                    <h4 class="p-1">{{ 'content.annual-sales-date' | translate }}</h4>
                    <div class="p-1 value">{{ formatDate(bizInfo.reportedDt) }}</div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3 report-labelled-cell">
                    <h4 class="p-1">{{ 'content.employees-num' | translate }}</h4>
                    <div class="p-1 value">{{ numberOfEmployees }}</div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3 report-labelled-cell">
                    <h4 class="p-1">{{ 'content.employees-num-date' | translate }}</h4>
                    <div class="p-1 value">{{ formatDate(numberOfEmployeesReportedDt) }}</div>
                  </div>
                </div>
}

                <div class="row">
                  <div class="col-12 row">
                    <h4 class="col-8 p-1">{{ 'content.prev-company-names' | translate }}</h4>
                    <h4 class="col-4 p-1">{{ 'content.reported-date' | translate }}</h4>
                    @for (name of prevLegalNames; track name) {
<div class="w-100 row value">
                      <div class="col-8 p-1">{{ name.name }}</div>
                      <div class="col-4 p-1">{{ formatDate(name.lastUpdatedDt) }}</div>
                    </div>
}
                  </div>
                  <div class="col-12 row">
                    <h4 class="col-8 p-1">{{ 'content.prev-company-operating-names' | translate }}</h4>
                    <h4 class="col-4 p-1">{{ 'content.reported-date' | translate }}</h4>
                    @for (name of prevOperatingNames; track name) {
<div class="w-100 row value">
                      <div class="col-8 p-1">{{ name.name }}</div>
                      <div class="col-4 p-1">{{ formatDate(name.lastUpdatedDt) }}</div>
                    </div>
}
                  </div>
                  <div class="col-12 row">
                    <h4 class="col-8 p-1">{{ 'content.prev-business-address' | translate }}</h4>
                    <h4 class="col-4 p-1">{{ 'content.reported-date' | translate }}</h4>
                    @for (address of prevAddresses; track address) {
<div class="w-100 row value">
                      <div class="col-8 p-1">{{ formatAddress(address) }}</div>
                      <div class="col-4 p-1">{{ formatDate(address.lastUpdatedDt) }}</div>
                    </div>
}
                  </div>
                  <div class="col-12 row">
                    <h4 class="col-4 p-1">{{ 'content.business-contact' | translate }}</h4>
                    <h4 class="col-4 p-1">{{ 'content.business-contact-title' | translate }}</h4>
                    <h4 class="col-4 p-1">{{ 'content.reported-date' | translate }}</h4>
                    @for (contact of contacts; track contact) {
<div class="w-100 row value">
                      <div class="col-4 p-1">{{ contact.contactFirstName }} {{ contact.contactLastName }}</div>
                      <div class="col-4 p-1">{{ contact.contactDesc }}</div>
                      <div class="col-4 p-1">{{ formatDate(contact.lastUpdatedDt) }}</div>
                    </div>
}
                  </div>
                </div>
              </div>
            </div>
}

            @if (business) {
<div class="col-sm-12 business-report-content indented-report-subsection grey break-before">
              <div class="row">
                <h3>{{ 'content.inquiries' | translate }}</h3>
              </div>
              @if (inquiries && inquiries.length > 0) {
<div class="w-100 col">
                <div class="w-100 row">
                  <h4 class="col-sm-2 p-1">{{ 'content.inquiry-date' | translate }}</h4>
                  <h4 class="col-sm-4 p-1">{{ 'content.inquiring-member' | translate }}</h4>
                  <h4 class="col-sm-3 p-1">{{ 'content.inquiry-phone-num' | translate }}</h4>
                  <h4 class="col-sm-3 p-1">{{ 'content.member-kob' | translate }}</h4>
                </div>
                @for (inquiry of inquiries; track inquiry) {
<div class="w-100 row value">
                  <div class="col-sm-2 p-1">{{ formatDate(inquiry.inquiryDt) }}</div>
                  <div class="col-sm-4 p-1">{{ inquiry.memberName }}</div>
                  <div class="col-sm-3 p-1">{{ reformatPhone(inquiry.memberPhone) }}</div>
                  <div class="col-sm-3 p-1">{{ kob(inquiry.memberCode) }}</div>
                </div>
}
              </div>
}
              @if (!inquiries || inquiries.length === 0) {
<div class="row">
                {{ 'content.no-inquiries' | translate }}
              </div>
}
            </div>
}

            @if (accounts && accounts.length > 0) {
<div>
              @for (account of accounts; track account) {
<div class="col-sm-12 business-report-content indented-report-subsection orange">
                <h3>
                  {{ 'content.accounts' | translate }}: {{ account.memberName }}
                  @if (isNotBlank(account.memberPhone)) {
<span class="ms-2">{{ reformatPhone(account.memberPhone) }}</span>
}
                </h3>
                <div class="row">
                  <div class="col-sm-12 col-md-6 col-lg-3">
                    <h4>{{ 'content.account' | translate }}</h4>
                    <div>{{ 'content.portfolio' | translate }}: {{ getAccountType(account) | async }}</div>
                    <div>{{ 'content.member-kob' | translate }}: {{ getKobDefinition(account.memberCode) | async }}</div>
                    <div>{{ 'content.account-number' | translate }}: {{ account.acctNum }}</div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3">
                    <h4>{{ 'content.activity' | translate }}</h4>
                    <div>{{ 'content.opened' | translate }}: {{ formatDate(account.openedDt) }}</div>
                    <div>{{ 'content.manner-of-payment' | translate }}: {{ getMopDescription(account.mop) | async }}</div>
                    <div>{{ 'content.last-updated' | translate }}: {{ formatDate(account.lastUpdatedDt) }}</div>
                    <div>{{ 'content.reported-date' | translate }}: {{ formatDate(account.reportedDt) }}</div>
                  </div>
                  <div class="col-sm-12 col-lg-6">
                    <h4>{{ 'content.balance-payments' | translate }}</h4>
                    <div class="row">
                      <div class="col-sm-12 col-md-6">
                        <div>{{ 'content.credit-limit' | translate }}: {{ i18nService.formatCurrency(account.creditLimit) | async }}</div>
                        <div>{{ 'content.high-credit' | translate }}: {{ i18nService.formatCurrency(account.highCreditAmt) | async }}</div>
                        <div>{{ 'content.balance' | translate }}: {{ i18nService.formatCurrency(account.currentBalance) | async }}</div>
                        <div>{{ 'content.amount-past-due' | translate }}: {{ i18nService.formatCurrency(account.amtPastDue) | async }}</div>
                        <div>{{ 'content.last-payment-date' | translate }}: {{ formatDate(account.lastPaymtDt) }}</div>
                      </div>
                      <div class="col-sm-12 col-md-6">
                        <div>{{ 'content.payment-due' | translate }}: {{ i18nService.formatCurrency(account.termsAmt, 0) | async }}</div>
                        <div>{{ 'content.narrative1' | translate }}: {{ account.narrativeCode1Text }}</div>
                        <div>{{ 'content.narrative2' | translate }}: {{ account.narrativeCode2Text }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <h4>{{ 'content.delinquency' | translate }}</h4>
                    <div>{{ 'content.first-delinquency-date' | translate }}: {{ formatDate(account.firstDelqDt) }}</div>
                    <div>{{ 'content.max-delinquency-date' | translate }}: {{ formatDate(account.maxDelqDt) }}</div>
                    <div>{{ 'content.max-delinquency' | translate }}: {{ getMopDescription(account.maxDelq) | async }}</div>
                    <div>{{ 'content.charge-off-date' | translate }}: {{ formatDate(account.chargoffDt) }}</div>
                    <div>{{ 'content.charge-off-amount' | translate }}: {{ i18nService.formatCurrency(account.chargoffAmt, 0) | async }}</div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <h4>{{ 'content.payment-pattern' | translate }}</h4>
                    <div>{{ 'content.pattern' | translate }}:</div>
                    @for (chunk of formatPaymentPattern(account.paymtPat); track chunk) {
<div>{{ chunk }}</div>
}
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <h4>{{ 'content.payment-history-months' | translate }}</h4>
                    <div>{{ 'content.overdue-30-59' | translate }}: {{ countPaymentPat(account.paymtPat, ['2']) }}</div>
                    <div>{{ 'content.overdue-60-89' | translate }}: {{ countPaymentPat(account.paymtPat, ['3']) }}</div>
                    <div>{{ 'content.overdue-90-or-more' | translate }}: {{ countPaymentPat(account.paymtPat, ['4', '5', '6', '7', '8', '9']) }}</div>
                    <div>{{ 'content.total-months' | translate }}: {{ account.paymtPat.length }}</div>
                  </div>
                </div>
              </div>
}
            </div>
}
            @if (!accounts || accounts.length === 0) {
<div class="col-sm-12">
              <div class="w-100 row business-report-content indented-report-subsection orange">
                <h3>{{ 'content.accounts' | translate }}</h3>
                <div class="col-sm-12">
                  <div class="row">
                    {{ 'content.no-trades' | translate }}
                  </div>
                </div>
              </div>
            </div>
}

            @if (bankruptcies && bankruptcies.length > 0) {
<div>
              @for (bankruptcy of bankruptcies; track bankruptcy) {
<div class="col-sm-12 business-report-content indented-report-subsection green">
                <h3>{{ 'content.business-insolvencies' | translate }}</h3>
                <div class="row">
                  <div class="col-sm-12 col-md-6 col-lg-3">
                    <h4>{{ 'content.insolvency' | translate }}</h4>
                    <div>{{ 'content.type' | translate }}: {{ getBankruptcyDefinition(bankruptcy.bkAdminType) | async }}</div>
                    <div>{{ 'content.reference' | translate }}: {{ bankruptcy.reference }}</div>
                    <div>{{ 'content.division' | translate }}: {{ bankruptcy.division }}</div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3">
                    <h4>{{ 'content.status' | translate }}</h4>
                    <div>{{ 'content.status' | translate }}: {{ bankruptcy.statusText }}</div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3">
                    <h4>{{ 'content.activity' | translate }}</h4>
                    <div>{{ 'content.reported' | translate }}: {{ formatDate(bankruptcy.reportedDt) }}</div>
                    <div>{{ 'content.filed' | translate }}: {{ formatDate(bankruptcy.filedDt) }}</div>
                    <div>{{ 'content.discharged' | translate }}: {{ formatDate(bankruptcy.dischargeDt) }}</div>
                    <div>{{ 'content.last-updated' | translate }}: {{ formatDate(bankruptcy.lastUpdatedDt) }}</div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3">
                    <h4>{{ 'content.info' | translate }}</h4>
                    <div>{{ 'content.trustee-name' | translate }}: {{ bankruptcy.trustee }}</div>
                    <div>{{ 'content.trustee-company' | translate }}: {{ bankruptcy.company }}</div>
                    <div>{{ 'content.trustee-phone' | translate }}: {{ reformatPhone(bankruptcy.trusteePhone) }}</div>
                    <div>{{ 'content.assets' | translate }}: {{ i18nService.formatCurrency(bankruptcy.assets) | async }}</div>
                    <div>{{ 'content.liabilities' | translate }}: {{ i18nService.formatCurrency(bankruptcy.liabilities) | async }}</div>
                  </div>
                </div>
              </div>
}
            </div>
}
            @if (!bankruptcies || bankruptcies.length === 0) {
<div class="col-sm-12">
              <div class="col-sm-12 business-report-content indented-report-subsection green">
                <div class="col-sm-12">
                  <h3>{{ 'content.business-insolvencies' | translate }}</h3>
                  <div class="col-sm-12">
                    <div class="row">
                      {{ 'content.no-bankruptcies' | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
}

            @if (business) {
<div class="col-sm-12 business-report-content indented-report-subsection grey">
              <div class="col-sm-12">
                <h3>{{ 'content.legal-items' | translate }}</h3>
                @for (legal of (legals || []); track legal; let i = $index) {
<div class="row" [ngClass]="{'mt-5': i > 0}">
                  <div class="col-sm-12 col-md-6 col-lg-4 p-1">{{ 'content.case-number' | translate }}: {{ legal.caseNumber }}</div>
                  <div class="col-sm-12 col-md-6 col-lg-4 p-1">{{ 'content.court-location' | translate }}: {{ legal.courtLocationText }}</div>
                  <div class="col-sm-12 col-md-6 col-lg-4 p-1">{{ 'content.court' | translate }}: {{ legal.courtText }}</div>
                  <div class="col-sm-12 col-md-6 col-lg-4 p-1">{{ 'content.date-filed' | translate }}: {{ formatDate(legal.judgementDt) }}</div>
                  <div class="col-sm-12 col-md-6 col-lg-8 p-1">{{ 'content.reason-code' | translate }}: {{ legal.reason }}</div>
                  <div class="col-sm-12 col-md-6 col-lg-4 p-1">{{ 'content.plaintiff-name' | translate }}: {{ legal.plaintiff }}</div>
                  <div class="col-sm-12 col-md-6 col-lg-4 p-1">{{ 'content.plaintiff-address' | translate }}: {{ legal.plaintiffAddr }}</div>
                  <div class="col-sm-12 col-md-6 col-lg-4 p-1">{{ 'content.plaintiff-phone' | translate }}: {{ reformatPhone(legal.plaintiffPhone) }}</div>
                  <div class="col-sm-12 col-md-6 col-lg-4 p-1">{{ 'content.procedure-code' | translate }}: {{ legal.type }}</div>
                  <div class="col-sm-12 col-md-6 col-lg-4 p-1">{{ 'content.description' | translate }}: {{ legal.typeText }}</div>
                  <div class="col-sm-12 col-md-6 col-lg-4 p-1">{{ 'content.amount' | translate }}: {{ i18nService.formatCurrency(legal.originalAmount, 0) | async }}</div>
                  <div class="col-sm-12 col-md-6 col-lg-4 p-1">{{ 'content.narrative' | translate }}: {{ legal.narrativeCode1Text }}</div>
                  <div class="col-sm-12 col-md-6 col-lg-4 p-1">{{ 'content.status' | translate }}: {{ legal.statusText }}</div>
                  <div class="col-sm-12 col-md-6 col-lg-4 p-1">{{ 'content.reported-date' | translate }}: {{ formatDate(legal.reportedDt) }}</div>
                </div>
}
                @if (!legals || legals.length === 0) {
<div class="row">
                  {{ 'content.no-legal-items' | translate }}
                </div>
}
              </div>
            </div>
}

            @if (business) {
<div class="col-sm-12 business-report-content indented-report-subsection grey">
              <div class="col-sm-12">
                <h3>{{ 'content.registered-items' | translate }}</h3>
                @for (registeredItem of (registeredItems || []); track registeredItem; let i = $index) {
<div class="row" [ngClass]="{'mt-5': i > 0}">
                  <div class="col-sm-12 col-md-6 col-lg-3">
                    <div class="ps-1 pe-1">{{ 'content.date-revised' | translate }}: {{ formatDate(registeredItem.reportedDt) }}</div>
                    <div class="ps-1 pe-1">{{ 'content.registration-num' | translate }}: {{ registeredItem.chattelNumber }}</div>
                    <div class="ps-1 pe-1">{{ 'content.subscriber-name' | translate }}: {{ registeredItem.memberName }}</div>
                    <div class="ps-1 pe-1">{{ 'content.member-address' | translate }}: {{ registeredItem.memberAddress }}</div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3">
                    <div class="ps-1 pe-1">{{ 'content.subscriber-telephone' | translate }}: {{ reformatPhone(registeredItem.memberPhone) }}</div>
                    <div class="ps-1 pe-1">{{ 'content.date-filed' | translate }}: {{ formatDate(registeredItem.filedDt) }}</div>
                    <div class="ps-1 pe-1">{{ 'content.date-mature' | translate }}: {{ formatDate(registeredItem.maturesDt) }}</div>
                    <div class="ps-1 pe-1">{{ 'content.original-balance' | translate }}
                      : {{ i18nService.formatCurrency(registeredItem.originalAmount) | async }}</div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3">
                    <div class="ps-1 pe-1">{{ 'content.security' | translate }}: {{ registeredItem.securityCodes }}</div>
                    <div class="ps-1 pe-1">{{ 'content.type' | translate }}: {{ getChattelTypeDescription(registeredItem) | async }}</div>
                    @if (displayOwnerNsbe()) {
<div class="ps-1 pe-1">{{ 'content.owner-nsbe' | translate }}: {{ registeredItem.ownerNsbe }}</div>
}
                    <div class="ps-1 pe-1">{{ 'content.mv-serial-num' | translate }}: {{ getChattelValue(registeredItem, "mvSerialNumber") }}</div>
                    <div class="ps-1 pe-1">{{ 'content.year' | translate }}: {{ getChattelValue(registeredItem, "year") }}</div>
                    <div class="ps-1 pe-1">{{ 'content.description' | translate }}: {{ getChattelValue(registeredItem, "description") }}</div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3">
                    <div class="ps-1 pe-1">{{ 'content.narrative1' | translate }}: {{ registeredItem.narrativeCode1Text }}</div>
                    <div class="ps-1 pe-1">{{ 'content.narrative2' | translate }}: {{ registeredItem.narrativeCode2Text }}</div>
                  </div>
                </div>
}
                @if (!registeredItems || registeredItems.length === 0) {
<div class="row">
                  {{ 'content.no-registered-items' | translate }}
                </div>
}
              </div>
            </div>
}

            @if (business) {
<div class="col-sm-12 business-report-content indented-report-subsection red">
              <div class="col-sm-12">
                <h3>{{ 'content.collections' | translate }}</h3>
                @for (collection of (collections || []); track collection; let i = $index) {
<div class="col-sm-12">
                  @if (i > 0) {
<hr/>
}
                  <div class="row">
                    <div class="col-sm-12 col-md-6 col-lg-3">
                      <h4 class="ps-1 pe-1">{{ 'content.date' | translate }}</h4>
                      <div class="ps-1 pe-1">{{ 'content.reported-date' | translate }}: {{ formatDate(collection.reportedDt) }}</div>
                      <div class="ps-1 pe-1">{{ 'content.revised-date' | translate }}: {{ formatDate(collection.lastUpdatedDt) }}</div>
                      <div class="ps-1 pe-1">{{ 'content.first-delinquency-date' | translate }}: {{ formatDate(collection.firstDelqDt) }}</div>
                      <div class="ps-1 pe-1">{{ 'content.paid-date' | translate }}: {{ formatDate(collection.paidDt) }}</div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3">
                      <h4 class="ps-1 pe-1">{{ 'content.agency-and-creditors-name' | translate }}</h4>
                      <div class="ps-1 pe-1">{{ 'content.agency' | translate }}: {{ collection.agency }}</div>
                      <div class="ps-1 pe-1">{{ 'content.creditor' | translate }}: {{ collection.creditor }}</div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3">
                      <h4 class="ps-1 pe-1">{{ 'content.amount' | translate }}</h4>
                      <div class="ps-1 pe-1">{{ 'content.original-balance' | translate }}
                        : {{ i18nService.formatCurrency(collection.originalAmount) | async }}</div>
                      <div class="ps-1 pe-1">{{ 'content.current-balance' | translate }}
                        : {{ i18nService.formatCurrency(collection.currentBalance) | async }}</div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3">
                      <h4 class="ps-1 pe-1">{{ 'content.status-and-narrative' | translate }}</h4>
                      <div class="ps-1 pe-1">{{ 'content.status' | translate }}: {{ collection.statusText }}</div>
                      <div class="ps-1 pe-1">{{ 'content.narrative1' | translate }}: {{ collection.narrativeCode1Text }}</div>
                      <div class="ps-1 pe-1">{{ 'content.narrative2' | translate }}: {{ collection.narrativeCode2Text }}</div>
                    </div>
                  </div>
                </div>
}
                @if (!collections || collections.length === 0) {
<div class="row">
                  {{ 'content.no-collections' | translate }}
                </div>
}
              </div>
            </div>
}

            @if (displayLumbermensQuickView()) {
<div class="w-100 row break-before">
              <ng-container *ngTemplateOutlet="titleBar; context:{titles:['content.supplier-segments' | translate],subtitle:'content.powered-by-lumbermens' | translate}"></ng-container>
              <div class="w-100 row business-report-content">
                <div class="w-100 row">
                  <div class="w-100 row">
                    <h3>{{ 'content.quick-view' | translate }}</h3>
                    <div class="w-100 row lumbermans-detail-row">
                      <div class="col-sm-12 col-md-6 col-lg-3 report-labelled-cell">
                        <h4 class="p-1">{{ 'content.num-of-suppliers' | translate }}</h4>
                        <div class="p-1 value">{{ getLumbermensQuickView('qvSupplierCount') }}</div>
                      </div>
                      <div class="col-sm-12 col-md-6 col-lg-3 report-labelled-cell">
                        <h4 class="p-1">{{ 'content.prompt-payment' | translate }}</h4>
                        <div class="p-1 value">{{ i18nService.formatCurrency(getLumbermensQuickView('qvPromptPayment')) | async }}</div>
                      </div>
                      <div class="col-sm-12 col-md-6 col-lg-3 report-labelled-cell">
                        <h4 class="p-1">{{ 'content.total-past-due' | translate }}</h4>
                        <div class="p-1 value">{{ i18nService.formatCurrency(getLumbermensQuickView('qvTotalPastDue')) | async }}</div>
                      </div>
                    </div>
                    <div class="w-100 row lumbermans-detail-row">
                      <div class="col ps-0 pe-0">
                        <h4>{{ 'content.total' | translate }}</h4>
                        <div>{{ i18nService.formatCurrency(getLumbermensQuickView('qvTotalDue')) | async }}</div>
                      </div>
                      <div class="col ps-0 pe-0">
                        <h4>{{ 'content.future' | translate }}</h4>
                        <div>{{ i18nService.formatCurrency(getLumbermensQuickView('qvFutue')) | async }}</div>
                      </div>
                      <div class="w-100 d-block d-md-none"></div>
                      <div class="col ps-0 pe-0">
                        <h4>{{ 'content.current' | translate }}</h4>
                        <div>{{ i18nService.formatCurrency(getLumbermensQuickView('qvCurrent')) | async }}</div>
                      </div>
                      <div class="w-100 d-none d-md-block d-xl-none"></div>
                      <div class="col ps-0 pe-0">
                        <h4>{{ 'content.1st-period' | translate }}</h4>
                        <div>{{ i18nService.formatCurrency(getLumbermensQuickView('qvDue30')) | async }}</div>
                      </div>
                      <div class="w-100 d-block d-md-none"></div>
                      <div class="w-100 d-block d-md-none"></div>
                      <div class="col ps-0 pe-0">
                        <h4>{{ 'content.2nd-period' | translate }}</h4>
                        <div>{{ i18nService.formatCurrency(getLumbermensQuickView('qvDue60')) | async }}</div>
                      </div>
                      <div class="col ps-0 pe-0">
                        <h4>{{ 'content.3rd-period' | translate }}</h4>
                        <div>{{ i18nService.formatCurrency(getLumbermensQuickView('qvDue90')) | async }}</div>
                      </div>
                      <div class="w-100 d-block d-md-none"></div>
                      <div class="col ps-0 pe-0">
                        <h4>{{ 'content.4th-period' | translate }}</h4>
                        <div>{{ i18nService.formatCurrency(getLumbermensQuickView('qvDue120')) | async }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
}

            @if (mergedLumberRecency && mergedLumberRecency.length > 0) {
<div class="w-100 col p-0 break-before">
              @for (lumbermensTradeAccountsList of mergedLumberRecency; track lumbermensTradeAccountsList) {
<div class="w-100">
                @for (lumbermensTradeAccount of lumbermensTradeAccountsList; track lumbermensTradeAccount) {
<div
                     class="w-100 col-sm-12 business-report-content indented-report-subsection orange">
                          <h3>{{ 'content.trades-section' | translate }}: {{ getLumbermensTradeName(lumbermensTradeAccount) }}</h3>
                          <app-lumbermens-trade-account-det
                            class="w-100 col-sm-12"
                            [lumbermensTradeAccountDet]="getLumbermensTradeDet(lumbermensTradeAccount)">
                          </app-lumbermens-trade-account-det>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              @if (!mergedLumberRecency || mergedLumberRecency.length === 0) {
                <div class="w-100 col p-0">
                  <div class="w-100 col business-report-content indented-report-subsection orange">
                    <div class="w-100 col">
                      <h3>{{ 'content.trades-section' | translate }}</h3>
                      <div class="w-100 col">
                        <div class="row">
                          {{ 'content.no-trades' | translate }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              @if (mergedLumberLastSale && mergedLumberLastSale.length > 0) {
                <div class="w-100 col p-0 break-before">
                  @for (lumbermensTradeAccountsList of mergedLumberLastSale; track lumbermensTradeAccountsList) {
                    <div>
                      @for (lumbermensTradeAccount of lumbermensTradeAccountsList; track lumbermensTradeAccount) {
                        <div class="w-100 col business-report-content indented-report-subsection green">
                          <h3>{{ 'content.automated-trade-submission' | translate }}</h3>
                          <app-lumbermens-automated-trade-submission-det class="w-100 col"
                          [lumbermensTradeAccount]="lumbermensTradeAccount"></app-lumbermens-automated-trade-submission-det>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              @if (!mergedLumberLastSale || mergedLumberLastSale.length === 0) {
                <div class="w-100 col p-0">
                  <div class="w-100 col business-report-content indented-report-subsection green">
                    <div class="w-100 col">
                      <h3>{{ 'content.automated-trade-submission' | translate }}</h3>
                      <div class="w-100 col">
                        <div class="row">
                          {{ 'content.no-automated-trades' | translate }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="tud-card mt-5">
            <h2>{{ 'content.disclaimer' | translate }}</h2>
            <div>{{ 'content.report-disclaimer' | translate }}</div>
          </div>
          <div class="col-sm-12 report-end content-main-title">{{ 'content.end-of-report' | translate }}</div>
        </div>
        @if (_appCard && _creditReport) {
          <app-pdf-button-bar newOrderUrl="/business-services" [css]="businessReportCss" [documentRootElement]="[_appCard, _creditReport]">
          </app-pdf-button-bar>
        }
        <ng-template #titleBar let-subtitle='subtitle' let-titles='titles'>
          <div class="row title-bar blue">
            @for (title of titles; track title) {
              <div class="title">{{ title }}</div>
            }
            <h2 class="subtitle no-underline">{{ subtitle }}</h2>
          </div>
        </ng-template>
        <ng-template #reportLabelledCell let-label="label" let-value="value">
          <div class="col-sm-12 col-md-6 col-lg-3 row report-labelled-cell">
            <h4 class="col-sm-12 p-1">{{ label }}</h4>
            <div class="col-sm-12 p-1 value">{{ value }}</div>
          </div>
        </ng-template>
      </div>
    }
  </ng-template>
</app-sidenav>
